"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _action = require("../../spinner-overlay/action");

var _action2 = require("../../notification/action");

var _constants = require("./constants");

var _service = require("./service");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(validateChannelsWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(validChannelsWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getIDsWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getIDsWorker);

function validateChannelsWatcher() {
  return regeneratorRuntime.wrap(function validateChannelsWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.ValidateChannelsType.VALIDATE_CHANNEL_LIST_REQUEST, validChannelsWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function validChannelsWorker(_ref) {
  var payload, response;
  return regeneratorRuntime.wrap(function validChannelsWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: 'Validating channels...'
          }));

        case 4:
          _context2.next = 6;
          return (0, _effects.put)({
            type: _constants.ValidateChannelsType.VALIDATE_CHANNEL_LIST_LOADING
          });

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(_service.validateChannelList, payload);

        case 8:
          _context2.next = 10;
          return (0, _effects.put)({
            type: _constants.ValidateChannelsType.VALIDATE_CHANNEL_LIST_SUCCESS
          });

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 12:
          _context2.next = 21;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](1);
          response = _context2.t0.response;
          _context2.next = 19;
          return (0, _effects.put)({
            type: _constants.ValidateChannelsType.VALIDATE_CHANNEL_LIST_FAILURE,
            payload: {
              response: response
            }
          });

        case 19:
          _context2.next = 21;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 21:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 14]]);
}

function getIDsWatcher() {
  return regeneratorRuntime.wrap(function getIDsWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.GetIDsType.GET_IDS_REQUEST, getIDsWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function getIDsWorker(_ref3) {
  var payload, response, _response$data, _response, errorMessage;

  return regeneratorRuntime.wrap(function getIDsWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          _context4.next = 3;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: 'Loading...'
          }));

        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _effects.call)(_service.getIds, payload);

        case 6:
          response = _context4.sent;
          _context4.next = 9;
          return (0, _effects.put)({
            type: _constants.GetIDsType.GET_IDS_SUCCESS,
            payload: response
          });

        case 9:
          _context4.next = 19;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](3);
          _response = _context4.t0.response;
          errorMessage = (_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context4.next = 17;
          return (0, _effects.put)((0, _action2.openNotification)('error', errorMessage, true, 3000));

        case 17:
          _context4.next = 19;
          return (0, _effects.put)({
            type: _constants.GetIDsType.GET_IDS_FAILURE,
            payload: {
              response: _response
            }
          });

        case 19:
          _context4.next = 21;
          return (0, _effects.put)((0, _action.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[3, 11]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(validateChannelsWatcher), (0, _effects.fork)(getIDsWatcher)]);

exports.default = _default;